// @ts-strict-ignore
import React from 'react';
import { useEffect, useState } from 'react';
import { ButtonReact } from 'common/components/button';
import { ButtonTheme } from 'common/components/button/constants';
import { InputReact } from 'common/components/input';
import { setUserFlag } from 'common/report/queries/app-api/user-flags';
import { UserFlag } from 'common/report/constants';
import { apiClient } from 'common/util/api-client';
import { FeedbackForFeature, Sentiment } from 'common/widgets/feedback-modal/types';
import { getLocation } from 'common/util/url';
import styles from './index.module.styl';
export const StarterBoardSurvey = _ref => {
  let {
    userEmail,
    projectId,
    dismiss
  } = _ref;
  const [clickedThumbsUpOrDown, setClickedThumsUpOrDown] = useState<boolean>(false);
  const [sentiment, setSentiment] = useState<Sentiment | null>(null);
  const [writtenFeedback, setWrittenFeedback] = useState<string>("");
  useEffect(() => {
    if (sentiment) {
      setClickedThumsUpOrDown(true);
      mixpanel.track("[Product Feedback] Starter Board", {
        sentiment,
        project_id: projectId
      });
    }
  }, [sentiment]);
  const handleClickDismiss = () => {
    setUserFlag(UserFlag.HideStarterBoardSurvey);
    dismiss();
  };
  const handleSubmitFeedback = () => {
    apiClient.post("/api/app/projects/".concat(projectId, "/product-feedback"), {
      feature: FeedbackForFeature.StarterBoard,
      feedback: writtenFeedback,
      feedback_type: "Unspecified",
      sentiment,
      customer_email: userEmail,
      url: getLocation().href
    });
    handleClickDismiss();
  };
  return clickedThumbsUpOrDown ? <div className={styles.starterBoardSurveyCard} data-sentry-component="StarterBoardSurvey" data-sentry-source-file="index.tsx">
      <div className={styles.starterBoardSurveyCardHeader}>
        <div className={styles.headerText}>Thank you! Please tell us more.</div>
        <ButtonReact icon={"x"} theme={ButtonTheme.Tertiary} onClick={handleClickDismiss} data-sentry-element="ButtonReact" data-sentry-source-file="index.tsx" />
      </div>
      <div className={styles.verbatim}>
        <InputReact type={"textarea"} autoFocus className={styles.input} onInput={ev => setWrittenFeedback(ev.target.state.value)} data-sentry-element="InputReact" data-sentry-source-file="index.tsx" />
        <ButtonReact onClick={handleSubmitFeedback} data-sentry-element="ButtonReact" data-sentry-source-file="index.tsx">Submit</ButtonReact>
      </div>
    </div> : <div className={styles.starterBoardSurveyCard} data-sentry-component="StarterBoardSurvey" data-sentry-source-file="index.tsx">
      <div className={styles.starterBoardSurveyCardHeader}>
        <div className={styles.headerText}>How would you rate the 🌱 Starter Board?</div>
        <ButtonReact icon={"x"} theme={ButtonTheme.Tertiary} onClick={handleClickDismiss} data-sentry-element="ButtonReact" data-sentry-source-file="index.tsx" />
      </div>
      <div className={styles.scores}>
        <div key={"thumbsDown"} className={styles.option} onClick={() => setSentiment(Sentiment.Negative)}>
          👎
        </div>
        <div key={"thumbsUp"} className={styles.option} onClick={() => setSentiment(Sentiment.Positive)}>
          👍
        </div>
      </div>
      <div className={styles.legend}>
        <div>Poor</div>
        <div>Excellent</div>
      </div>
    </div>;
};